import { Component } from '@angular/core';
import { CalendarsOperations } from '../store/reducers/calendars-operation';
import { ResetWorkingTimeSchema } from '../store/actions/calendars.actions';
import { Store } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

@Component({
    selector: 'working-time-schema-calendar',
    templateUrl: 'working-time-schema-calendar.component.html',
    styleUrls: ['working-time-schema-calendar.component.scss']
})

export class WorkingTimeSchemaCalendarComponent {
    public currentDateType: string;
	public startDate: Date = new Date();
	public finishDate: Date = new Date();
    public onDate: Date = new Date();

    constructor(private _store: Store<IAppState>) { }

    applyResetOnDays() {
        const workingTimeSchemaFake = CalendarsOperations.getEmptyWorkingTimeSchema();
      if (this.currentDateType === 'exact') {
        workingTimeSchemaFake.fromDate = CalendarsOperations.getStringDate(this.onDate);
        workingTimeSchemaFake.toDate = CalendarsOperations.getStringDate(this.onDate);
      } else {
        workingTimeSchemaFake.fromDate = CalendarsOperations.getStringDate(this.startDate);
        workingTimeSchemaFake.toDate = CalendarsOperations.getStringDate(this.finishDate);
      }
      this._store.dispatch(new ResetWorkingTimeSchema(workingTimeSchemaFake));
      this._resetDates();
    }

    private _resetDates() {
        this.currentDateType = 'exact';
        this.startDate = new Date();
        this.finishDate = new Date();
        this.onDate = new Date();
    }

}
